export default __webpack_public_path__ + "static/media/CPAMarketingToolkitLogo.7fdfa1f0.png";